
/*
 *  Add an existing product from the inventory list
 */
angular.module('qkr').controller('AddProductFromInventoryController', ($scope, currentCategoryId,
                                                              allowedCreateMenuItems, $uibModalInstance,
                                                                       menuService, merchantService,
                                                              inventoryService, departmentService,
                                                              utils, appConfig, menuItems, messageService) => {
    $scope.query = '';
    $scope.inventoryproducts = '';
    $scope.saveSuffix = '';
    $scope.checkedCount = 0;
    $scope.initialCategoryId = currentCategoryId;
    $scope.selectedCategoryId = currentCategoryId;
    $scope.allowEditOnOutletLevel =
        merchantService.behaviour(merchantService.merchantInfo, 'inventoryPage.allowEditOnOutletLevel');
    $scope.isEditable = (appConfig.isElevatedUser && !appConfig.outletLevel) || $scope.allowEditOnOutletLevel;
    $scope.allowedCreateMenuItems = allowedCreateMenuItems;
    $scope.currentMenu = menuService.getCurrentMenu();

    const productInMenu = (test) => {
        let found = false;
        if (!utils.hasNoValue(menuItems)) {
            for (let j = 0; j < menuItems.length; j++) {
                const prod = menuItems[j];
                if (prod.sku === test.sku) {
                    found = true;
                }
            }
        }
        return found;
    };

    inventoryService.loadInventory().then((promise) => {
        $scope.inventoryproducts = promise;
        angular.forEach($scope.inventoryproducts, (prod) => {
            prod.selected = false;
            prod.inMenu = productInMenu(prod);
        });

        $scope.inventoryproductsloaded = true;
    });

    $scope.updateCheckedItem = function(prod) {
        if (prod.selected) {
            $scope.checkedCount += 1;
        } else {
            $scope.checkedCount -= 1;
        }

        $scope.saveSuffix = $scope.checkedCount > 0 ? ' ' + $scope.checkedCount + '*' : $scope.saveSuffix = '';
    };
    
    $scope.save = function() {
        let num = 0;
        const addList = [];
        angular.forEach($scope.inventoryproducts, (prod) => {
            if (prod.selected) {
                num++;
                addList.push(prod);
            }
        });
        
        if (num > 0) {
            $scope.saving = true;
            menuService.addMenuItems(addList, $scope.currentMenu)
                .then(() => {
                    if (departmentService.getCurrentDepId()) {
                       // MenuService.loadMenus(departmentService.currentDepartmentId)
                        menuService.loadMenus(departmentService.getCurrentDepId())
                            .then(() => {
                            $scope.saving = false;
                            $uibModalInstance.close('reload');
                            messageService.saveAlert();
                        });
                    } else {
                        $scope.saving = false;
                        $uibModalInstance.close('reload');
                        messageService.saveAlert();
                    }
            });
        } else {
            $uibModalInstance.close('reload');
        }
    };

    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };
    
    $scope.reloadProductCategories = function() {
        // Load all the products
        inventoryService.loadProductCategoriesForInventory()
            .then((promise) => {
                $scope.categories = promise;

                const noempty = [];
                for (let i = 0; i < $scope.categories.length; i++) {
                    if ($scope.categories[i].numItems !== 0)
                        noempty.push($scope.categories[i]);
                }
                $scope.categories = noempty;
        });
    };

    $scope.reloadProductCategories();    // Initially load categories
});



// WEBPACK FOOTER //
// ./src/controllers/modal/addProductFromInventory.controller.js